import { h, render, Fragment } from 'preact';
import MainView from './views/main.view';

export class App {
    constructor(selector) {
        this.rootElement = document.querySelector(selector);
    }

    get app() {
        return (
            <Fragment>
                <MainView />
            </Fragment>
        );
    }

    init() {
        render(this.app, this.rootElement);
    }
}
